import React from 'react'
import styled from 'styled-components'
import Image from 'common/image'
import StepArrow from 'assets/step_arrow.svg'
import { useTranslation } from 'react-i18next'

const BoxContainer = styled.div`
    background-color: #fafafa;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 40px 0px;
`

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 247px;
    margin-right: 40px;
    margin-left: 40px;
`

const StepText = styled.div`
    width: 247px;
    height: 50px;
    margin-top: 40px;
    color: #4e3821;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px; /* 125% */
`

const SubTitleText = styled.div`
    padding-top: 12px;
    color: #835d35;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    
`

const ContentText = styled.div`
    padding-top: 16px;
    color: #835d35;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const StepArrowContainer = styled.div`
    display: flex;
    height: 558px;
`

interface StepItem {
    path_en?: string
    path_zh?: string
    step_en?: string
    step_zh?: string
    text_en?: string
    text_zh?: string
    content_en?: string
    content_zh?: string
}

interface StepItems extends Array<StepItem> {}

interface StepsComponentProps {
    stepItems?: StepItems
}

export default function StepsComponent(props: StepsComponentProps) {
    const { i18n } = useTranslation()
    const lang = i18n.language
    const { stepItems } = props
    const handledStepItems = stepItems

    return (
        <BoxContainer>
            {handledStepItems?.map((item: StepItem, index: number) => {
                return (
                    <React.Fragment key={`step-tutorial-privilege-` + index}>
                        <StepContainer>
                            <Image
                                src={
                                    lang === 'zh'
                                        ? item.path_zh || ''
                                        : item.path_en || ''
                                }
                                width={275}
                                height={468}
                                alt="Steps Picture"
                            />
                            <StepText>
                                {lang === 'zh' ? item.step_zh : item.step_en}
                            </StepText>
                            {item.text_en ? (
                                <SubTitleText>
                                    {lang === 'zh'
                                        ? item.text_zh
                                        : item.text_en}
                                </SubTitleText>
                            ) : null}
                            <ContentText>
                                {lang === 'zh'
                                    ? item.content_zh
                                    : item.content_en}
                            </ContentText>
                        </StepContainer>
                        {index + 1 < handledStepItems?.length ? (
                            <StepArrowContainer>
                                <Image
                                    src={StepArrow}
                                    width={16}
                                    height={250}
                                    alt="Step Arrow Icon"
                                    style={{
                                        alignSelf: 'flex-end',
                                        flexShrink: '0',
                                    }}
                                />
                            </StepArrowContainer>
                        ) : null}
                    </React.Fragment>
                )
            })}
        </BoxContainer>
    )
}
